export const NULL_PROJECT = 'default-project' as const;
